export const getErrorMessage = (error) => {
    let errorMessage = "Something went wrong!";
    if (error && error.response && error.response.data) {
        if (error.response.headers['content-type'] === "application/json") {
            if (typeof error.response.data === "string") {
                return error.response.data;
            } else if (typeof error.response.data === "object") {
                return error.response.data.message;
            } else {
                return errorMessage;
            }
        } else {
            return errorMessage;
        }
    } else {
        return errorMessage;
    }
}